// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const DifferenceChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="DifferenceChartIcon" ref={forwardedRef} {...props}>
      <path d="M3 3h1.494v2.07l6.757 3.73L17 5.631v8.052l-5.75-3.173-6.756 3.721V15.5h12.453V17H3.997A1 1 0 0 1 3 16zm1.494 9.521 5.204-2.867-5.204-2.872z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const DifferenceChartIcon = /* @__PURE__ */ Object.assign(
  DifferenceChartIconComponent,
  { displayName: 'DifferenceChartIcon' },
);
